import Vue from 'vue';
import axios from 'axios';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';

import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';

Vue.http = axios;
Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyCxEeep4GdsyVQxWkj3rAObKXW-2s2rahA',
  // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  installComponents: true,
  // Optional (default: true) - false, if you want to locally install components
  vueGoogleMapsCompatibility: false,
  // Optional (default: false) - true, requires vue2-google-maps to be configured see https://github.com/xkjyeah/vue-google-maps
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
